// Password input with a show/hide toggle. Wraps `Input` so it keeps the same height, border and
// error state; the eye button sits inside the right edge at the tap-target minimum. The toggle is a
// plain `type="button"` so it never submits the form, and `aria-pressed` tells assistive tech
// whether the password is currently visible.
'use client';

import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Input, type InputProps } from './Input';

export type PasswordInputProps = Omit<InputProps, 'type'>;

export function PasswordInput({ className = '', ...rest }: PasswordInputProps) {
  const [visible, setVisible] = useState(false);
  const Icon = visible ? EyeOff : Eye;
  return (
    <div className="relative">
      <Input type={visible ? 'text' : 'password'} className={['pr-s8', className].join(' ')} {...rest} />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? 'Sembunyikan kata sandi' : 'Tampilkan kata sandi'}
        aria-pressed={visible}
        aria-controls={rest.id}
        className="absolute inset-y-0 right-0 inline-flex min-h-tap-min min-w-tap-min items-center justify-center text-ink-soft hover:text-ink"
      >
        <Icon aria-hidden="true" className="h-s5 w-s5" />
      </button>
    </div>
  );
}
